module.exports = __webpack_public_path__ + "static/img/banner4.84c0f21.png";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/onlinePreview/banner4.png
// module id = iEUx
// module chunks = 2